import { ADMIN_API } from '../AdminAPI';
export function createFeatureFlagService(api) {
    return {
        getPlayerFeatureFlag(id) {
            return api.fetch(ADMIN_API.GET_PLAYER_FEATURE_FLAG, { config: { urlParams: { id } } });
        },
        updatePlayerFeauteFlag(id, data) {
            return api.fetch(ADMIN_API.PATCH_PLAYER_FEATURE_FLAG, { data, config: { urlParams: { id } } });
        }
    };
}
//# sourceMappingURL=FeatureFlagService.js.map